import HeroBaggage from 'shared/lib/assets/img/landing/hero-baggage.png';
import LogoBlueRibbonBags from 'shared/lib/assets/img/logo/logo-blue-ribbon-bags.svg';

export const baggageConfig = {
  hero: {
    heading: 'Packing was hard. Protecting your stuff is easy.',
    subheading:
      'Tracking down lost luggage is no way to spend your vacation—so if you’re one of the estimated 12,000 U.S. travelers who lose their bags while flying domestically each year, we’ve got you covered.',
    cta: 'Get baggage insurance',
    ctaLink: '/baggage-protection/address',
    img: HeroBaggage,
  },
  underwriter: {
    img: LogoBlueRibbonBags,
    name: 'Blue Ribbon Bags',
  },
  coverageDetails: [
    {
      heading: 'Baggage Loss, Damage, or Theft',
      subheading:
        'Coverage for your belongings means you won’t be left in a lurch (without clean socks) should the worst happen.',
    },
    {
      heading: 'Valuables Loss, Damage, Or Theft',
      subheading: 'Protect what you love most when you’re far from home.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Baggage Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'You finally landed in sunny Hawaii—but your luggage is chilling in Iceland.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'You arrive at your host’s home and discover that the gift you brought her has been stolen from your bag.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'Your baggage is banged up— making it out of the country intact, but just barely.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
